import styled from 'styled-components';
import { TextCSS } from './Text';

export const Description = styled.div`
  ${TextCSS({})}
  white-space: pre-line;
  text-align: center;
  padding: 0 ${(props) => `4${props.theme.unit}`};
  gap: ${(props) => `2${props.theme.unit}`};
`;
